import React from 'react'
import { notification } from '../../../components/Notifications'
import { useEdlink } from './useEdlink'
import { useIdp } from './useIdp'
import { CognitoAuthenticator } from './CognitoAuthenticator/CognitoAuthenticator'

type LoginMethod = 'local' | 'edlink' | 'idp' | 'invalid-tenant-information' | 'undefined'

// • Maps a tenant’s `loginMethod` to the correct authentication flow (local Cognito, Edlink SSO redirect, or external IdP)
// • Each entry either returns a React component to render (local) or triggers a side-effect and returns null (SSO redirects)
// • Includes a fallback handler for invalid tenant info (shows error notification) and a safe no-op for undefined
export const useAuthFlowMap = ({
  email,
  loginMethod,
  handleBack = () => {}
}: {
  email: string
  loginMethod?: LoginMethod
  handleBack?: () => void
}): any => {
  if (!loginMethod) return null
  const redirectToEdlinkSSO = useEdlink()
  const { signInWithIdp } = useIdp()

  const authProvidersMap: Record<LoginMethod, () => JSX.Element | Promise<null> | null> = {
    local: () => {
      localStorage.setItem('authType', 'cognito')
      return (<CognitoAuthenticator
      email={email}
      onBack={() => {
        handleBack()
      }}
    />)
    },

    edlink: () => {
      redirectToEdlinkSSO()
      return null
    },
    idp: () => {
      localStorage.setItem('authType', 'cognito')
      void signInWithIdp()
      return null
    },

    'invalid-tenant-information': () => {
      notification(
        'Failed to fetch login method. Please contact classranked support.',
        { variant: 'error' }
      )
      return null
    },
    undefined: () => <></>
  }

  return { authProvidersMap, loginMethod }
}
